import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlInputModule, BlFocusModule } from '@blcloud/bl-ng-ui-component';

import { RedirectPageComponent } from './redirect-page.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BlNgCommonModule,
    BlInputModule,
    BlFocusModule,
  ],
  declarations: [
    RedirectPageComponent,
  ],
})
export class RedirectPageModule {}



// WEBPACK FOOTER //
// ./src/app/page/redirect-page/redirect-page.module.ts